import React, { useEffect, useRef, useState } from 'react';
import { Loader2, Send } from 'lucide-react';

export const STATUS_CLS = {
  Received: 'bg-sky-50 text-sky-800', 'In progress': 'bg-amber-50 text-amber-800', Resolved: 'bg-emerald-50 text-emerald-800',
};

const when = (iso) => new Date(iso).toLocaleString(undefined, { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });

export const RequestThread = ({ req, side, onSend }) => {
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const end = useRef(null);
  useEffect(() => { end.current?.scrollIntoView({ block: 'nearest' }); }, [req.messages.length]);
  const send = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setBusy(true); setErr('');
    try { await onSend(text); setText(''); } catch (x) { setErr(x?.response?.data?.detail || 'Could not send. Please try again.'); } finally { setBusy(false); }
  };
  const mine = (m) => m.from === side;
  return (
    <div className="space-y-3" data-testid={`thread-${req.id}`}>
      {req.details && <div className="text-sm text-stone-700 whitespace-pre-wrap rounded-lg bg-stone-50 border border-stone-200 p-3">{req.details}</div>}
      <div className="space-y-2 max-h-72 overflow-y-auto">
        {req.messages.length === 0 && <div className="text-xs text-stone-400">No replies yet.</div>}
        {req.messages.map((m) => (
          <div key={m.id} className={`flex ${mine(m) ? 'justify-end' : 'justify-start'}`} data-testid={`msg-${m.id}`}>
            <div className={`max-w-[85%] rounded-2xl px-3.5 py-2 text-sm ${mine(m) ? 'bg-emerald-800 text-white rounded-br-sm' : 'bg-white border border-stone-200 text-stone-800 rounded-bl-sm'}`}>
              <div className="whitespace-pre-wrap">{m.text}</div>
              <div className={`text-[10px] mt-1 ${mine(m) ? 'text-emerald-100' : 'text-stone-400'}`}>{m.name} · {when(m.at)}</div>
            </div>
          </div>
        ))}
        <div ref={end}/>
      </div>
      <form onSubmit={send} className="flex gap-2">
        <input value={text} onChange={(e) => setText(e.target.value)} placeholder="Write a reply…" maxLength={4000}
          className="flex-1 h-10 rounded-lg border border-stone-300 px-3 text-sm focus:outline-none focus:border-emerald-700" data-testid={`reply-input-${req.id}`}/>
        <button type="submit" disabled={busy || !text.trim()} className="h-10 px-4 rounded-lg bg-emerald-800 text-white text-sm font-medium inline-flex items-center gap-1.5 disabled:opacity-50 hover:bg-emerald-900 transition-colors" data-testid={`reply-send-${req.id}`}>
          {busy ? <Loader2 size={14} className="animate-spin"/> : <Send size={14}/>} Send
        </button>
      </form>
      {err && <div className="text-xs text-red-600" data-testid={`reply-error-${req.id}`}>{String(err)}</div>}
    </div>
  );
};
